import { render, staticRenderFns } from "./base-label.vue?vue&type=template&id=96edba0e&"
import script from "./base-label.vue?vue&type=script&lang=js&"
export * from "./base-label.vue?vue&type=script&lang=js&"
import style0 from "./base-label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports